<span #mathText data-testid="math-text" class="math-text"></span>
